/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    AfterContentChecked,
    ChangeDetectionStrategy,
    Component,
    DoCheck,
    EventEmitter,
    Injector,
    OnChanges,
    OnDestroy,
    OnInit,
    Optional,
    Output,
    SimpleChanges,
    SkipSelf,
} from '@angular/core';
import { isolatedReportFactory, TypedReportDirective } from '../typed-report.directive';
import { IsolatedReportService } from '../../services/isolatedReport.service';

@Component({
    selector: 'dash-gis-data-report',
    templateUrl: './data-report.component.html',
    styleUrls: ['./data-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: IsolatedReportService,
            useFactory: isolatedReportFactory,
            deps: [Injector, [new Optional(), new SkipSelf(), IsolatedReportService]],
        },
    ],
})
export class DataReportComponent
    extends TypedReportDirective
    implements OnInit, OnChanges, OnDestroy, DoCheck, AfterContentChecked {
    reportData: any[];

    @Output() protected edit = new EventEmitter<any>();

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngDoCheck(): void {
        super.ngDoCheck();
    }

    ngAfterContentChecked() {
        super.ngAfterContentChecked();
    }
}
